// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue';
import Unauthorized from 'src/pages/GeneralViews/UnauthorizedPage'
import Landing from "@/pages/GeneralViews/Landing";
import DashboardLayout from "@/pages/Layout/DashboardLayout";
import AboutUs from "@/pages/AboutUs";
import NewsAndUpdates from "@/pages/NewsAndUpdates";
import Pricing from "@/pages/Pricing";
import Features from "@/pages/Features";
import GetDemo from "@/pages/GetDemo";
import ContactUs from "@/pages/ContactUs";


const routes = [
  {
    path: '/',
    name: 'Home',
    component: DashboardLayout,
    children: [
      {
        path: '/',
        name: 'Landing',
        components: { default: Landing }
      },
      {
        path: '/about',
        name: 'About',
        components: { default: AboutUs }
      },
      {
        path: '/contact',
        name: 'Contact Us',
        components: { default: ContactUs }
      },
      {
        path: '/updates',
        name: 'Updates',
        components: { default: NewsAndUpdates }
      },
      {
        path: '/pricing',
        name: 'Pricing',
        components: { default: Pricing }
      },
      {
        path: '/features',
        name: 'Features',
        components: { default: Features }
      },
      {
        path: '/demo',
        name: 'Demo',
        components: { default: GetDemo }
      },
    ]
  },
  { path: '/forbidden', component: Unauthorized },
  { path: '*', component: NotFound }
];

export default routes;
